import React, { memo } from 'react';
export const FooterSection = memo(function FooterSection() {
  return <footer className="bg-gray-900 text-gray-400 py-8 px-4 text-center text-sm border-t border-gray-800" data-id="element-52">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-53">
        <p data-id="element-54">
          © 2026 DescargaTop – Pack 100 Citas Todos los derechos reservados
        </p>
        <div className="flex justify-center gap-4" data-id="element-55">
          <a href="#" className="hover:text-white transition-colors" data-id="element-56">
            Privacidad
          </a>
          <span data-id="element-57">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-58">
            Términos y Condiciones
          </a>
        </div>
      </div>
    </footer>;
});